import api from "@/utils/request";
const url = "/web";

// 预订通知单查询
export function getOrderNotice(params) {
  return api.post(url + `/book/getOrderQuery`, params);
}
export function getListReport(params) {
  return api().get(`/app/follower/listReport`, { params });
}
export function exportReport(params) {
  return api.post(
    "/app/follower/exportReport?followerName=" +
      params.followerName +
      "&hasConverted=" +
      params.hasConverted +
      "&managerName=" +
      params.managerName +
      "&beginDate=" +
      params.beginDate +
      "&endDate=" +
      params.endDate +
      "&pageNum=" +
      params.pageNum +
      "&pageSize=" +
      params.pageSize +
      "",
    {},
    "blob"
  );
}

// 预订通知单订单统计信息
export function getOrderInfo(params) {
  return api.post(url + `/book/getOrderQueryCountInfo`, params);
}

//导出excel
export function exportBookingNotice(params) {
  return api.post(url + `/book/exportBookingNotice`, params, "blob");
}

//获取详情
export function getOrderInfoByOrder(params) {
  return api().get(url + `/book/getOrderInfoByOrderId`, { params });
}

//获取详情
export function getOperationLogs(params) {
  return api().get(url + `/book/getOperationLogs`, { params });
}

// 历史通知单查询
export function getHistoryOrderNotice(params) {
  return api.post(url + `/book/getHistoryNotice?pageNum=${params.offset/params.pageSize+1}&pageSize=${params.pageSize}` , params);
}

// 历史预订通知单订单统计信息
export function getHistoryNoticeCountInfo(params) {
  return api.post(url + `/book/getHistoryNoticeCountInfo`, params);
}

// 订单金额录入查询
export function getAmountEntry(params) {
  return api.post(url + `/book/getAmountEntry`, params);
}

// 订单金额录入保存
export function saveAmountEntry(params) {
  return api.post(url + `/book/saveAmountEntry`, params);
}

//获取详情
export function getAllRestaurantOrderSort() {
  return api().get(url + `/book/getAllRestaurantOrderSort`);
}

// 查询已锁台的桌位
export function getLockTables(params) {
  return api.post("/app/lockTables/query", params);
}
// 查询所有桌位的锁台状态
export function getAllTablesLockStatus(params) {
  return api.post("/app/lockTables/queryWithLock", params);
}
// 将桌位进行解锁
export function unLocktables(params) {
  return api.post("/app/lockTables/unlock", params);
}

// 查询未锁台的桌位
export function getDeskByAreaDesk(params) {
  return api().get(url + "/bookSetting/getDeskByAreaDesk", { params });
}

// 将桌位进行锁台
export function lockTable(params) {
  return api.post("/app/lockTables/lock", params);
}
// ****** 核餐 ******
export function saveCheckMeal(params) {
  return api.post("/app/checkMeal/saveCheckMeal", params);
}
// ****** 摆台页面 ******
// 获取开台/翻台情况
export function getOpeningInfo(params) {
  return api().get("/app/order/getOpeningInfo", { params });
}
export function getNoArriveInfo(params) {
  return api().get("/app/order/getNoArriveInfo", { params });
}
// 摆台
export function assignTable(params) {
  return api.post("/app/order/assignTableWeb", params);
}

// ***** 客到页面 *****
// 对桌位进行开台
export function openTable(params) {
  return api.post("/app/order/openTable", params);
}
export function closeTable(params) {
  return api.post("/app/order/closeTable", params);
}

// ***** 撤桌页面 *****
// 获取撤桌原因
export function getAllLabel(params) {
  return api().get("/pad/banquet/getAllLabel", { params: params });
}
// 减桌
export function minusDesk(params) {
  return api.post("/pad/order/minusDesk", params);
}

// ***** 加桌页面 *****
// 加桌
export function addDesk(params) {
  return api.post("/pad/order/addDesk", params);
}

// ***** 调桌页面 *****
// 调桌
export function adjustDesk(params) {
  return api.post("/pad/order/adjustDesk", params);
}

// ***** 修改订单 *****
// 获取订单详情
export function getOrderDeatils(params) {
  return api.post("/app/order/searchOrderForDetails", params);
}

// ***** 撤单统计 *****
// 查询撤单统计列表
export function queryCancelOrderList(params) {
  return api.post("/pad/manage/queryCancelOrderList", params);
}
export function commemorationQuery(params) {
  return api().get("/app/commemoration/query", { params });
}
export function queryDictData(params) {
  return api().get(
    "/app/customer/queryDictData?dictType=sys_commemoration_day",
    { params }
  );
}
export function commemorationAdd(params) {
  return api.post("/app/commemoration/add", params);
}
export function commemorationDelete(params) {
  return api().get("/app/commemoration/delete?commemorationId="+params.commemorationId, {  });
}
export function followerList(params) {
  return api().get("/app/follower/list?orderId="+params.orderId, {  });
}
export function followerAdd(params) {
  return api.post("/app/follower",params);
}